module.exports = __webpack_public_path__ + "images/FUSA_icons/022-search.f0bfc541ea83a12b385143bcf5b1bf24.svg";